export default {
    props: {
        color: {
            type: String,
            default: "#ffffff"
        },
        width: {
            type: [Number, String],
            default: "100%"
        },
        height: {
            type: [Number, String],
            default: "100%"
        }
    }
}